import styled from 'styled-components'
import { CardProps } from './index'

const StyledCard = styled.div<Pick<CardProps, 'width'>>`

  @import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,400;0,500;1,700&display=swap');

  width: ${p => p.width};
  height: 320px;
  font-family: Red Hat Display;
  font-weight: 500;
  font-size: 25px;
  background-color: #fff;
  margin: 0.625rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px #bdbdbd;
  text-transform: capitalize;
  transition: 0.2s;
  text-align: center;
  
  img {
  margin:0.625rem;
  width: 90%;
  height: 250px;
  object-fit: cover;
  }

 img:hover {
 width: 95%;
}
 

`

export default StyledCard
